if (!customElements.get('wavex-navigation')) {
  customElements.define('wavex-navigation', class WavexNavigation extends HTMLElement {
    connectedCallback() {
      this.menu = this.querySelector('[data-wavex-menu]');
      this.toggle = this.menu?.querySelector('summary');
      if (!this.menu || !this.toggle) return;

      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.media = window.matchMedia('(min-width: 1120px)');

      this.updateExpanded = () => {
        this.toggle.setAttribute('aria-expanded', String(this.menu.open));
        this.toggle.setAttribute('aria-label', this.menu.open ? 'Close navigation menu' : 'Open navigation menu');
      };
      this.closeMenu = (restoreFocus = false) => {
        if (!this.menu.open) return;
        this.menu.open = false;
        this.updateExpanded();
        if (restoreFocus) this.toggle.focus();
      };

      this.menu.addEventListener('toggle', this.updateExpanded, options);
      this.menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.menu.open) {
          event.preventDefault();
          event.stopPropagation();
          this.closeMenu(true);
        }
      }, options);
      this.menu.addEventListener('click', (event) => {
        if (event.target.closest('a')) this.closeMenu();
      }, options);
      document.addEventListener('pointerdown', (event) => {
        if (!this.menu.contains(event.target)) this.closeMenu();
      }, options);
      document.addEventListener('focusin', (event) => {
        if (!this.menu.contains(event.target)) this.closeMenu();
      }, options);
      this.media.addEventListener('change', () => {
        if (this.media.matches) this.closeMenu();
      }, options);

      this.resizeObserver = new ResizeObserver(() => {
        document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
      });
      this.resizeObserver.observe(this);
      this.updateExpanded();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
    }
  });
}
